import React, { FC, useMemo } from 'react'

import * as SC from './styled'

export type StepperProps = {
  className?: string
  currentStep?: number
  totalSteps?: number
}

const Stepper: FC<StepperProps> = (props) => {
  const { className, currentStep = 0, totalSteps = 12 } = props

  const renderSteps = useMemo(() => {
    return [...Array(totalSteps).keys()].map((_, idx) => (
      <SC.Step
        key={`stepper-${idx}`}
        className={currentStep === idx + 1 ? '-current' : ''}
      />
    ))
  }, [totalSteps, currentStep])

  return (
    <SC.Stepper className={`${className} ${currentStep === 0 && `-empty`}`}>
      <SC.Steps>{renderSteps}</SC.Steps>
    </SC.Stepper>
  )
}

export default Stepper
